<style xmlns="http://www.w3.org/1999/html">
    .header-home-nav, .home-footer {
        background: url(~@/assets/hometeacher/images/green-green-fon.png) !important;
        padding-bottom: 10px;
    }

</style>

<template>
    <div>
        <div class="container-fluid blue-letters-girl">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / Годовой курс испанского языка
                        </div>

                        <h1 class="desktop-vers">Годовой курс испанского языка</h1>
                        <h1 class="mobile-vers">Годовой курс<br> <span class="yellow-span">испанского языка</span></h1>

                        <h3>для детей от 3 до 12 лет</h3>
                        <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;"><img
                                src="~@/assets/hometeacher/images/girl-esp.jpg" alt="Годовой курс испанского языка"
                                class="mobile girl-notik"></div>
                        <p>Индивидуальное обучение ребёнка с помощью уроков-эпизодов с участием преподавателя-наставника.</p>

                        <p><span class="strong-black">Личный куратор во время онлайн-встреч контролирует результаты обучения, проводит оценку знаний ребёнка, составляет индивидуальный план его развития и помогает добиваться отличных результатов! </span>
                        </p>

                        <p>Ребёнок легко усвоит основы испанского языка, даже если до этого никогда его не изучал.
                          Мы стимулируем к запоминанию благодаря игровой форме обучения, используем творческие задания, игры, поделки, онлайн-тренажеры.
                          Ребенок с интересом проходит уроки-эпизоды, которые чередуются с индивидуальным онлайн-консультациями преподавателя.</p>

                        <p class="desktop-vers"><span class="blue-fon-text">Дети развиваются, интересно проводят время, изучая испанский</span>
                            <br>
                            <span class="blue-fon-text">как второй родной язык.</span></p>

                        <p class="mobile-vers"><span class="blue-fon-text">Дети развиваются,</span><br>
                            <span class="blue-fon-text">интересно проводят время,</span><br>
                            <span class="blue-fon-text">изучая испанский как</span><br>
                            <span class="blue-fon-text">как второй родной язык.</span></p>

                        <div class="knpk"><a href="javascript:void(0);" @click="tryFree">Подать заявку</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid vkurs">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check">
                        <label for="check"><h2 class="iba">Курс "Испанский для детей"</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <img src="~@/assets/hometeacher/images/girl-wow-esp.jpg"
                                 alt="Годовой курс испанского языка">
                            <div>
                                <p style="font-size: 3px;">&nbsp;</p>
                                <div class="chek"></div>
                                <p><span class="strong-black">72 урока-эпизода</span> для детей продолжительностью 25-30
                                    минут каждый</p>
                                <div class="chek"></div>
                                <p><span class="strong-black">210 рабочих PDF-листов</span> для распечатки к занятиям
                                </p>
                                <div class="chek"></div>
                                <p><span class="strong-black">80 интерактивных онлайн-игр</span> и онлайн-тест для
                                    запоминания</p>
                                <div class="chek"></div>
                                <p><span class="strong-black">40</span> песен</p>
                               <div class="chek"></div>
                                <p><span class="strong-black"><a href="https://poliglotiki.com/home-teacher/schedule/lang/es">Безлимитные групповые онлайн-занятия</a> по расписанию с преподавателем</span></p>

                                <p class="onlain-kons" style="background-image: none;">При покупке годового курса становятся доступны все онлайн-уроки по расписанию</p>
                                <div class="red-chek"></div>
                                <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Ежемесячные индивидуальные онлайн-консультации педагога</span>
                                </p>
                                <p>оценка знаний, тестирование, составление плана и темпа занятий, контроль результатов.</p>
                                <div class="red-chek"></div>
                                <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">За дополнительную плату приобретайте индивидуальные онлайн-занятия с преподавателем по предмету</span>
                                </p>

                            </div>
                            <h3>Длительность всего курса: 1 год. </h3>
                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2 class="iba desktop-vers">Курс "Испанский для детей"</h2>

                        <img src="~@/assets/hometeacher/images/girl-wow-esp.jpg" alt="Годовой курс испанского языка">


                        <div class="chek"></div>
                        <p><span class="strong-black">72 урока-эпизода</span> для детей продолжительностью 25-30 минут
                            каждый</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">210 рабочих PDF-листов</span> для распечатки к занятиям</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">80 интерактивных онлайн-игр</span> и онлайн-тест для запоминания
                        </p>
                        <div class="chek"></div>
                        <p><span class="strong-black">40</span> песен</p>
                        <p style="font-size: 3px;">&nbsp;</p>
                      <div class="red-chek"></div>
                      <p><span class="strong-black"><a href="https://poliglotiki.com/home-teacher/schedule/lang/es">Безлимитные групповые онлайн-занятия</a> по расписанию с преподавателем</span></p>

                      <p class="onlain-kons" style="background-image: none;">При покупке годового курса становятся доступны все онлайн-уроки по расписанию</p>
                      <div class="red-chek"></div>
                      <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Ежемесячные индивидуальные онлайн-консультации педагога</span>
                      </p>
                      <p>оценка знаний, тестирование, составление плана и темпа занятий, контроль результатов.</p>
                      <div class="red-chek"></div>
                      <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">За дополнительную плату приобретайте индивидуальные онлайн-занятия с преподавателем по предмету</span>
                      </p>

                        <h3>Длительность всего курса: 1 год. </h3>
                    </div>

                </div>
            </div>
        </div>
        <div class="container-fluid orangetop"></div>
        <div class="container-fluid orangefon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h2>С “Полиглотиками”<br> учить испанский язык — <br>
                            <span class="veselo">эффективно и интересно!</span></h2>
                        <p>Первый бесплатный урок-эпизод продемонстрирует, как мы учим, какие онлайн-тренажеры,
                            материалы для скачивания и песни будут доступны в течение всего курса.
                            А во время первой онлайн-консультации куратор проведет диагностику, подберет уровень курса,
                            составит план занятий.</p>
                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Попробовать
                            бесплатно</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid orangedown"></div>

        <div class="container-fluid blue-letters-back">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Ставьте цели и <span class="viborabonement">выбирайте абонемент:</span>
                        </h2>
                        <h2 class="mobile-vers">Ставьте цели<br>
                            <div class="viborabonement">и выбирайте<br> абонемент:</div>
                        </h2>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />


            </div>
        </div>
        <!--
        <div class="container-fluid align-middle getpresent">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="desktop-vers">При покупке курса <span class="toget">вы получаете в подарок:</span>
                        </h3>
                        <h3 class="mob">При покупке курсы <br>
                            <div class="toget">вы получаете в<br> подарок 5 курсов:</div>
                        </h3>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <StudyProductCourseList
                                :courses="courses"
                                @about="aboutCourse"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid bigwavetop desktop-vers"></div>
        <div class="container-fluid liniya mobile-vers"></div>
        -->
        <div class="container-fluid obuchenie">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check1">
                        <label for="check1"><h2 class="iba">Как проходит обучение</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight1"></div>
                                    <div class="bluekrug">1</div>
                                    <p>Мы назначаем первую онлайн-консультацию с куратором, который <span
                                            class="strong-black">оценивает уровень знаний</span> и составляет план.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug">2</div>
                                    <p>Каждую неделю весь учебный год назначаются <span class="strong-black">2 урока-эпизода.</span>
                                    </p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="bluekrug">3</div>
                                    <p>Всю неделю ребенок <span class="strong-black">изучает</span> темы из
                                        уроков-эпизодов.</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug">4</div>
                                    <p><span class="strong-black">Выполняет домашние задания</span> в формате
                                        онлайн-тренажеров.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug" style="margin-bottom: 70px;">5</div>
                                    <p>Ежемесячно (и чаще) персональный наставник проводит <span class="strong-black">онлайн-встречи</span>
                                        с ребенком и родителями для контроля достижения результатов</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="bluekrug">6</div>
                                    <p><span class="strong-black">Оказываем поддержку 7/24.</span> Чат с куратором для
                                        любых вопросов.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2>Как проходит обучение</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight1"></div>
                        <div class="bluekrug">1</div>
                        <p>Мы назначаем первую онлайн-консультацию с куратором, который <span class="strong-black">оценивает уровень знаний</span>
                            и составляет план.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">2</div>
                        <p>Каждую неделю весь учебный год назначаются <span class="strong-black">2 урока-эпизода.</span>
                        </p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="bluekrug">3</div>
                        <p>Всю неделю ребенок <span class="strong-black">изучает</span> темы из уроков-эпизодов.</p>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-9">
                        <img src="~@/assets/hometeacher/images/strelka-krivaya.png" class="strelka-krivaya">
                    </div>

                    <div class="col-12 col-sm-3">
                        <img src="~@/assets/hometeacher/images/hello.png" class="hello">
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">4</div>
                        <p><span class="strong-black">Выполняет домашние задания</span> в формате онлайн-тренажеров.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">5</div>
                        <p>Ежемесячно (и чаще) персональный наставник проводит <span
                                class="strong-black">онлайн-встречи</span> с ребенком и родителями для контроля
                            достижения результатов</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="bluekrug">6</div>
                        <p><span class="strong-black">Оказываем поддержку 7/24.</span> Чат с куратором для любых
                            вопросов.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter desktop-vers" style="margin-top: 90px;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid liniya mobile-vers"></div>
        <div class="container-fluid white-bg no-shadow sm-video" style="padding-top: 0px;">
            <div class="container align-middle">

                <div class="row">
                    <div class="col-12">
                        <h2 style="margin-top: 40px; line-height: 1.3;">По окончании обучения<br>
                            <span class="sertifikat">ребенок получает сертификат</span></h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:3}}">

                            <div class="centers-text mx-3">
                                <img src="@/assets/hometeacher/images/esp-sertifikat-1.jpg">
                            </div>
                            <div class="centers-text mx-3">
                                <img src="@/assets/hometeacher/images/esp-sertifikat-2.jpg">
                            </div>
                            <div class="centers-text mx-3">
                                <img src="@/assets/hometeacher/images/esp-sertifikat-3.jpg">
                            </div>

                        </carousel>
                    </div>
                </div>

            </div>
        </div>

        <div class="container-fluid bigwavetop desktop-vers"></div>
        <div class="container-fluid liniya mobile-vers"></div>

        <div class="container-fluid white-bg no-shadow sm-video">
            <div class="container align-middle">
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2>Смотрите видео о курсе испанского</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:3}}">

                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/d6X7b-uDXRY" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Курс испанского языка от центров Полиглотики</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/gWGq5M3yesE" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Курс испанского для детей. Unit 1. Lesson 1</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/pzxPufSVA10" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Курс испанского для детей. Unit 1. Lesson 2</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/uWSk6QVKbFA" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Курс испанского для детей. Unit 1. Lesson 3</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/23qEDLwj2Nc" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Курс испанского для детей. Unit 1. Lesson 4</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/yUDPGGW2bPg" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Курс испанского для детей. Unit 1. Lesson 5</p>
                            </div>

                        </carousel>
                    </div>
                </div>


                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check3">
                        <label for="check3"><h2>Смотрите видео о курсе испанского</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">

                            <carousel :responsive="{0:{items:1},1000:{items:3}}">

                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/d6X7b-uDXRY" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Курс испанского языка от центров Полиглотики</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/gWGq5M3yesE" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Курс испанского для детей. Unit 1. Lesson 1</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/pzxPufSVA10" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Курс испанского для детей. Unit 1. Lesson 2</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/uWSk6QVKbFA" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Курс испанского для детей. Unit 1. Lesson 3</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/23qEDLwj2Nc" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Курс испанского для детей. Unit 1. Lesson 4</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/yUDPGGW2bPg" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Курс испанского для детей. Unit 1. Lesson 5</p>
                                </div>

                            </carousel>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="land-t-delimeter desktop-vers" style="margin-top: 90px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid liniya mobile-vers"></div>

        <div class="container-fluid white-bg no-shadow sm-video">
            <div class="container align-middle">

                <div class="row">
                    <div class="col-12">
                        <h2 class="otzivh2">Отзывы родителей</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:2}}">

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/tatyana-tumanova.jpg">
                                <span class="nameotzyv">Татьяна Туманова</span>
                                <div class="text-otziv">Отличный курс. Ребёнку очень нравится. Все понятно и доступно.
                                    Приятные преподаватели
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/no-avatar-1.png">
                                <span class="nameotzyv">Марина</span>
                                <div class="text-otziv">Посоветовал этот курс педагог в языковом центре Полиглотики,
                                    чтобы закрепить песенный материал, который изучали на занятии, развить чувство ритма
                                    и расширить...
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/elena-serebryakova.jpg">
                                <span class="nameotzyv">Елена Серебрякова</span>
                                <div class="text-otziv">Курс полезный, особенно, малышам которые занимаются в
                                    Полиглотиках он-лайн и на очных занятиях. Так как он является словарной базой для
                                    занятий, детей по ним обучают...
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/no-avatar-2.png">
                                <span class="nameotzyv">Марина</span>
                                <div class="text-otziv">Курс с флеш-карточками помог нам выучить дополнительные слова на
                                    английском, значительно расширить словарный запас с минимумом усилий. Как маме мне
                                    было очень интересно...
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
                <div class="row" style="margin-top: 70px; margin-bottom: 50px;">
                    <div class="col-12" style="text-align: center;">
                        <a href="/all-comments.html" class="allotzv">Читать все отзывы</a>
                    </div>
                </div>

            </div>
        </div>


        <div class="container-fluid orangetop"></div>
        <div class="container-fluid orangefon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h2>С “Полиглотиками”<br> учить испанский язык — <br>
                            <span class="veselo">эффективно и интересно!</span></h2>
                        <p>На пробном онлайн-занятии преподаватель проводит диагностику, подбирает уровень курса,
                            составляет план развития ученика.
                            Пробное занятие открывает один урок-эпизод курса и тренажеры к нему.</p>
                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Попробовать
                            бесплатно</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid orangedown-white desktop-vers"></div>
        <div class="container-fluid orangedown mobile-vers"></div>
        <div class="container-fluid last-stav">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Ставьте цели и <span class="viborabon-last">выбирайте абонемент:</span>
                        </h2>
                        <h2 class="mobile-vers">Ставьте цели<br>
                            <div class="viborabonement">и выбирайте<br> абонемент:</div>
                        </h2>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />

            </div>
        </div>


        <Entry/>

    </div>
</template>

<script>
    import carousel from "vue-owl-carousel";
    import moment from 'moment';
    import StudyProductSubscriptionList from "./Study/landing/StudyProductSubscriptionList";
    import studyProductApi from "../data/StudyProductApi";
    import Entry from "./Entry";
    import courseApi from "../data/CourseApi";
    import StudyProductCourseList from "./Study/landing/StudyProductCourseList";


    export default {
        components: {
            StudyProductCourseList,
            StudyProductSubscriptionList,
            carousel,
            Entry,
        },
        name: "GodovojKursIspanskogoYazyka",

        data: function () {
            return {
                title: null,
                slug: 'godovoj-kurs-ispanskogo-yazyka',
                subscriptions: [],
                freeSubscription: null,
                promoSuscription: null,
                courses: [],
            }
        },

        mounted() {
            moment.locale(this.$i18n.locale)
            this.loading = true

            studyProductApi.fetchStudyProductSlug(this.slug)
                .then(response => {
                    this.subscriptions = response.subscriptions.filter(s => {
                        if (s.price <= 0) {
                            this.freeSubscription = s
                            return false
                        }
                        return s.price > 0
                    })
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            /*courseApi.fetchCourseBySlug('ispanskij-dlya-detej-nachinayushchie')
                .then(response => {
                    this.courses.push(response)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            courseApi.fetchCourseBySlug('ispanskij-dlya-detej-prodolzhayushchie')
                .then(response => {
                    this.courses.push(response)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            courseApi.fetchCourseBySlug('ispanskij-dlya-detej-prodvinutye')
                .then(response => {
                    this.courses.push(response)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })*/

        },

        methods: {
            orderSubscription(subscription) {
                this.$router.push('/subscription/order/' + subscription.idsubscription)
            },
            aboutCourse(course) {
                this.$router.push('/course/' + course.slug + '/details')
            },
            tryFree() {
                if (this.freeSubscription) {
                    this.$router.push('/subscription/order/' + this.freeSubscription.idsubscription)
                }
            }
        },

        metaInfo() {
            return {
                title: 'Годовой курс Испанского языка',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: 'Годовой курс Испанского языка для детей от 12 месяцев до 12 лет.'
                    }
                ]
            }
        },
    }
</script>

<style scoped>

    .blue-letters-girl {
        background: url(~@/assets/hometeacher/images/blue-letters-girl-esp.jpg) no-repeat center;
        text-align: left;
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 10px;
        min-height: 878px;
    }

    .breadcrumbs {
        font-size: 14px;
        background: #fff;
        max-width: 290px;
        padding-left: 7px;
        border-radius: 10px;
        margin-left: -7px;
    }

    .blue-letters-girl h1 {
        font-size: 50px;
        font-family: Manrope Black;
        margin-top: 15px;
        margin-bottom: 0px;
        color: #000;
        background: url(~@/assets/hometeacher/images/yellow-span-esp.png) no-repeat right center;
        max-width: 797px;
        padding-top: 2px;
    }

    .blue-letters-girl h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        margin-bottom: 20px;
        color: #000;
    }

    .blue-letters-girl p {
        font-size: 20px;
        max-width: 750px;
    }

    .blue-fon-text {
        background: #00b4f1;
        color: #fff;
        border-radius: 15px;
        padding: 2px 10px;
        font-size: 19px;
        font-family: 'Manrope Book';
        margin-left: 0px;
    }

    .knpk {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 22px;
        color: #fff;
        padding: 15px 30px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
        margin-top: 30px;
    }

    .knpk:hover {
        background: #49d92c;
    }

    .knpk a {
        color: #fff;
    }

    .vkurs {
        padding-top: 60px;
    }

    .vkurs h2 {
        font-size: 40px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 30px;
    }

    .vkurs h3 {
        font-size: 25px;
        font-family: "Manrope Bold";
        color: #231c37;
        margin-top: 30px;
    }

    .vkurs img {
        float: right;
        margin-right: -35px;
    }

    .vkurs p {
        font-size: 20px;
        margin-left: 35px;
        line-height: 1.4;
        color: #000;
        max-width: 599px !important;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 85px;
    }

    .leftp {
        margin-left: 0px !important;
    }

    .red-chek {
        background: url(~@/assets/hometeacher/images/red-chek.png) no-repeat 0 0;
        font-size: 20px;
        float: left;
        width: 25px;
        height: 20px;
        margin-top: 8px;
    }

    .bezlimit-group {
        background-image: url(~@/assets/hometeacher/images/bezlimit-group.png);
        line-height: 1.6 !important;
        padding-left: 8px;
        padding-bottom: 3px;
        padding-right: 8px;
        max-width: 589px !important;
    }

    .onlain-kons {
        background-image: url(~@/assets/hometeacher/images/onlain-kons.png);
        line-height: 1.4 !important;
        padding-left: 8px;
        padding-bottom: 0px;
        padding-right: 8px;
        max-width: 654px !important;
        padding-top: 2px;
    }

    .chek {
        background: url(~@/assets/hometeacher/images/chek.png) no-repeat 0 0;
        font-size: 20px;
        float: left;
        width: 25px;
        height: 20px;
        margin-top: 8px;
    }

    .orangetop {
        background: url(~@/assets/hometeacher/images/orangetop.png) repeat center;
        width: 100%;
        height: 90px;
        margin-top: 50px;
    }

    .orangedown {
        background: url(~@/assets/hometeacher/images/orangedown.png) repeat center;
        width: 100%;
        height: 93px;
        margin-top: -1px;
    }

    .orangedown-white {
        background: url(~@/assets/hometeacher/images/orangedown-white.png) repeat center;
        width: 100%;
        height: 92px;
    }

    .orangefon {
        background: #f18100;
        min-height: 350px;
        overflow: hidden;
        padding-bottom: 0px;
        padding-top: 30px;
    }

    .orangefon img {
        float: right;
        margin-right: -415px;
        margin-top: 107px;
        height: 33px;
        max-width: 100%;
    }

    .orangefon h2 {
        font-family: Manrope Bold Alt;
        font-size: 40px;
        color: #fff;
        margin-top: 50px;
        line-height: 1.3;
    }

    .orangefon p {
        color: #fff;
        font-size: 18px;
        line-height: 1.4;
        margin-top: 20px;
    }

    .veselo {
        background-image: url(~@/assets/hometeacher/images/effect.png);
        padding-left: 8px;
        padding-top: 2px;
        padding-bottom: 8px;
        color: #000;
        padding-right: 8px;
    }

    .knpk-yellow {
        border-radius: 35px;
        text-align: center;
        max-width: 390px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#ffce00), to(#fbfe00));
        font-size: 24px;
        padding: 15px 30px;
        -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        margin-top: 90px;
    }

    .knpk-yellow:hover {
        background: #fbfe00;
    }

    .knpk-yellow a {
        color: #000;
    }

    .blue-letters-back {
        background-image: url(~@/assets/hometeacher/images/blue-letters-back.png);
        margin-top: 0;
        padding-bottom: 100px;
        text-align: left;
        padding-top: 70px;
    }

    .blue-letters-back h2 {
        font-size: 40px;
        font-family: "Manrope Black";
        color: #262239;
    }

    .viborabonement {
        background-image: url(~@/assets/hometeacher/images/viborabonement.png);
        padding-left: 8px;
        padding-top: 1px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .abonement {
        max-width: 254px;
        min-height: 233px;
        border: 1px solid #d9e0e4;
        background: #fff;
        text-align: center;
        margin-top: 50px;
        border-radius: 10px;
        box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
    }

    .month-1, .month-3, .month-6, .month-12 {
        font-size: 22px;
        text-align: center;
        font-family: "Manrope Bold Alt";
        margin-bottom: 15px;
    }

    .month-1 {
        background: url(~@/assets/hometeacher/images/month-1.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-3 {
        background: url(~@/assets/hometeacher/images/month-3.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-6 {
        background: url(~@/assets/hometeacher/images/month-6.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-12 {
        background: url(~@/assets/hometeacher/images/month-12.png) no-repeat center;
        margin-top: 4px;
        color: #fff;
    }

    .price {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #72717d;
    }

    .rubls {
        font-size: 18px;
    }

    .econom {
        font-size: 15px;
        color: #231c37;
        margin-bottom: 17px;
        margin-top: -6px;
        text-shadow: 0px 0px 0px rgb(0 0 0);
        font-weight: bold;
    }

    .all-course {
        color: #ed1c24;
        font-family: "Manrope Black";
        font-size: 18px;
    }

    .abonement a {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 20px;
        color: #fff;
        padding: 14px 35px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
    }

    .abonement a:hover {
        background: #49d92c;
    }

    .getpresent {
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 100px;
    }

    .getpresent h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 40px;
    }

    .toget {
        background-image: url(~@/assets/hometeacher/images/toget.png);
        padding-left: 8px;
        padding-top: 3px;
        padding-bottom: 10px;
        padding-right: 8px;
    }

    .bigwavetop {
        background: url(~@/assets/hometeacher/images/bigwavetop.png) no-repeat center;
        width: 100%;
        height: 190px;
    }

    .present {
        width: 220px;
        height: 469px;
        border: 1px solid #d7e1e5;
        margin-right: -1px;
        padding: 20px;
        overflow: hidden;
        margin: 0 auto 10px auto;
    }

    .present img {
        border-radius: 10px;
    }

    .podarok {
        margin-left: 95px;
        margin-top: -285px;
    }

    .dific {
        margin-top: -30px;
    }

    .present h4 {
        font-family: "Manrope Bold";
        font-size: 18px;
        color: #262239;
        line-height: 1;
        margin-top: -9px;
        margin-bottom: 12px;
    }

    .present h4 a {
        color: #262239;
    }

    .present p {
        font-family: "Manrope Book";
        color: #4f4d5c;
        font-size: 14px;
        line-height: 1;
        margin-bottom: 10px;
    }

    .cennik {
        font-family: "Manrope Bold";
        font-size: 20px;
        color: #262239;
        position: absolute;
        bottom: 20px;
    }

    .cennik span {
        color: #4f4d5c;
        font-size: 16px;
        font-family: "Manrope Light";
        font-weight: bold;
    }

    .obuchenie {
        padding-top: 100px;
        padding-bottom: 60px;
        box-shadow: inset 0 3px 5px #00000038;
    }

    .obuchenie h2, .sm-video h2 {
        font-size: 40px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 60px;
    }

    .obuchenie p {
        font-size: 18px;
        width: 270px;
        line-height: 1.4;
    }

    .strela {
        background-image: url(~@/assets/hometeacher/images/strela.png);
        width: 176px;
        height: 19px;
        margin-top: 20px;
        left: 100px;
        position: absolute;
    }

    .bluekrug {
        width: 60px;
        height: 60px;
        border: 3px solid #00b4f1;
        border-radius: 50%;
        text-align: center;
        color: #4f4d5c;
        background: #fff;
        padding-top: 10px;
        font-size: 24px;
        font-family: "Manrope Bold";
        margin-bottom: 20px;
        position: relative;
        z-index: 10;
    }

    .strelka-krivaya {
        margin-left: 35px;
        margin-top: -40px;
        padding-bottom: 5px;
        max-width: 100%;
    }

    .hello {
        position: absolute;
        top: -150px;
        left: -20px
    }

    .sertifikat {
        background-image: url(~@/assets/hometeacher/images/sertifikat.png);
        padding-left: 8px;
        padding-top: 3px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .sm-video {
        padding-top: 80px;
    }

    .sm-video p {
        margin-top: -100px;
        font-size: 18px;
        font-family: 'Manrope Book';
        color: #000;
        text-align: center;
    }

    .vidos {
        width: 100%;
        height: 192px;
        border-radius: 15px;
        margin-right: 0 !important;
        margin-bottom: 100px !important;
    }

    .otzivh2 {
        font-size: 36px !important;
        font-family: "Manrope Black" !important;
        color: #231c37 !important;
        margin-bottom: 60px !important;
    }

    .indotz {
        float: left;
        margin-right: 20px;
    }

    .nameotzyv {
        font-size: 21px;
        font-family: Manrope Bold;
        display: block;
        color: #000;
    }

    .text-otziv {
        font-size: 17px;
        color: #000;
        line-height: 1.4;
        margin-top: 10px;
    }

    .centers-text {
        max-width: 500px;
    }

    .allotzv {
        color: #0493c3;
        font-size: 20px;
        font-family: "Manrope Bold";
        padding: 15px 30px;
        border: 2px solid #0493c3;
        border-radius: 30px;
    }

    .allotzv:hover {
        background: #0493c3;
        color: #fff;
    }

    .viborabon-last {
        background-image: url(~@/assets/hometeacher/images/viborabon-last.png);
        padding-left: 8px;
        padding-top: 1px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .last-stav {
        padding-top: 70px;
        padding-bottom: 120px;
    }

    .last-stav h2 {
        font-size: 40px;
        font-family: "Manrope Bold Alt";
        color: #262239;
    }

    .girl-notik {
        margin-left: -25px;
        margin-bottom: 20px;
        max-width: 110%;
    }

    .liniya {
        background-image: url(~@/assets/hometeacher/images/liniya.png);
        width: 100%;
        height: 36px;
        margin-top: 30px;
    }

    @media (max-width: 1199px) {
        .obuchenie {
            overflow: hidden;
        }

        .hello {
            top: -110px;
            left: -115px;
        }

        .cennik {
            position: inherit;
        }
    }

    @media (max-width: 991px) {
        .abonement a {
            padding: 10px;
        }

        .centers-text {
            max-width: 100%;
            text-align: center;
        }

        .vidos {
            height: 370px;
        }

        .indotz {
            float: none;
            margin-bottom: 20px;
        }

        .blue-letters-girl h1 {
            background: none;
        }

        .bezlimit-group, .onlain-kons {
            background: none;
        }

        .obuchenie p {
            width: 100%;
        }

        .strela {
            display: none;
        }

        .hello {
            top: -160px;
        }
    }

    input[type="checkbox"] {
        display: none;
    }

    label {
        cursor: pointer;
        color: #fff;
        text-decoration: underline;
        -moz-user-select: -moz-none;
        -webkit-user-select: none;
        user-select: none;
    }

    .block {
        width: 100%;
        display: none;
    }

    input:checked ~ .block {
        display: block;
    }

    .galocka {
        margin-right: 0px !important;
        margin-top: -110px;
        float: right !important;
    }

    @media (max-width: 575px) {
        .blue-letters-girl {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-bottom: 60px;
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
        }

        .blue-letters-girl h1 {
            font-size: 40px;
            line-height: 1.1;
        }

        .blue-letters-girl h3 {
            font-size: 22px;
            margin-top: 10px;
        }

        .yellow-span {
            background-image: url(~@/assets/hometeacher/images/yellow-span-esp-mob.png);
            font-size: 30px;
            padding-left: 12px;
            padding-top: 0px;
            padding-bottom: 0px;
            padding-right: 7px;
        }

        .vkurs {
            padding-left: 15px !important;
            padding-right: 15px !important;
            box-shadow: inset 0 3px 5px rgb(0 0 0 / 22%);
        }

        .vkurs h2 {
            font-size: 33px;
        }

        .vkurs img {
            float: none;
            max-width: 80%;
            margin-right: 0px !important;
        }

        .orangefon, .blue-letters-back {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 0px;
            padding-bottom: 10px;
        }

        .orangefon h2 {
            font-size: 25px;
            line-height: 1.5;
        }

        .orangefon img {
            display: none;
        }

        .orangetop {
            margin-top: 0px;
            margin-bottom: -1px;
        }

        .veselo {
            background-image: url(~@/assets/hometeacher/images/effect-mob.png);
            padding-left: 7px;
            padding-top: 3px;
            padding-bottom: 5px;
            color: #000;
            padding-right: 4px;
        }

        .knpk-yellow {
            margin-top: 40px;
            font-size: 20px;
            padding: 15px;
        }

        .blue-letters-back h2, .last-stav h2 {
            font-size: 33px;
            text-align: center;
        }

        .viborabonement {
            background-image: url(~@/assets/hometeacher/images/viborabonement-mob.png);
            width: 240px;
            line-height: 1.2;
            margin: 0 auto;
            padding-top: 1px;
            padding-bottom: 2px;
            margin-bottom: 30px;
            margin-top: -10px;
        }

        .abonement {
            margin: 0 auto;
            margin-bottom: 30px;
        }

        .abonement a {
            padding: 15px 35px;
        }

        .getpresent {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 60px;
            text-align: center;
        }

        .toget {
            background-image: url(~@/assets/hometeacher/images/toget-mob.png);
            text-align: left;
            width: 285px;
            line-height: 1.2;
            margin: 0 auto;
            padding-top: 1px;
            padding-bottom: 10px;
            margin-bottom: 30px;
            margin-top: -10px;
        }

        .present {
            float: none;
            margin: auto;
            width: 270px;
            height: 450px;
            text-align: left;
            box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
            border-radius: 10px;
        }

        .podarok {
            margin-left: 145px;
        }

        .cennik {
            position: absolute;
        }

        .obuchenie {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 50px;
            padding-bottom: 0px;
            margin-bottom: -20px
        }

        .obuchenie h2 {
            font-size: 33px;
        }

        .bluekrug {
            float: left;
            margin-right: 10px;
            margin-bottom: 40px;
        }

        .sm-video, .last-stav {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 0px;
        }

        .sm-video h2 {
            font-size: 30px;
        }

        .sertifikat {
            background: none;
            padding-left: 0px;
        }

        .vidos {
            height: 280px;
        }

        .last-stav {
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
            padding-bottom: 0px;
        }
    }

    @media (max-width: 404px) {
        .veselo {
            background: #fcff00;
            border-radius: 15px;
            font-size: 22px;
            padding-left: 10px;
            color: #000;
            padding-right: 10px;
        }
    }

    @media (max-width: 370px) {
        .veselo {
            font-size: 19px;
        }
    }
</style>
